import classnames from 'classnames';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { snakeCase } from '@fundera/fundera-utilities';
import Header from './SecondaryNavMobileHeader';
import SubMenu from './SecondaryNavMobileSubMenu';
import SubHeader from './SecondaryNavMobileSubHeader';

import * as styles from './SecondaryNavMobile.module.less';

const getKey = props => {
  if (!props) return null;
  const { path, text } = props;
  return snakeCase(`${path}-${text}`);
};

const SecondaryNavMobileCollapsible = ({ link, isOpen, onClick, text }) => {
  const [activeTab, setActiveTab] = useState(getKey(link?.childItems?.[0]));
  const onTabClick = anchorId => {
    setActiveTab(anchorId);
  };
  return (
    <div
      className={styles.individualEntry}
      data-spy="scroll"
      data-target={styles.wrapperOpen}
    >
      <Header isOpen={isOpen} text={text} onClick={onClick} />
      <SubHeader
        activeTab={activeTab}
        getKey={getKey}
        isOpen={isOpen}
        link={link}
        onClick={onTabClick}
      />
      <div
        className={classnames(styles.wrapper, {
          [styles.wrapperOpen]: isOpen,
        })}
      >
        <ul className={classnames(styles.list)}>
          {link?.childItems.map(childItem => (
            <SubMenu
              key={`sub-menu-${getKey(childItem)}`}
              links={{
                ...childItem,
                name: childItem.text,
                anchorId: getKey(childItem),
              }}
              activeTab={activeTab}
              onClick={onTabClick}
              isOpen
            />
          ))}
        </ul>
      </div>
    </div>
  );
};

SecondaryNavMobileCollapsible.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  link: PropTypes.shape({
    path: PropTypes.string,
    name: PropTypes.string,
    childItems: PropTypes.arrayOf(PropTypes.object),
  }),
  onClick: PropTypes.func,
  text: PropTypes.string,
};

SecondaryNavMobileCollapsible.defaultProps = {
  link: null,
  onClick: () => {},
  text: '',
};

export default SecondaryNavMobileCollapsible;
